import Swiper from "swiper";
import { Navigation } from "swiper/modules";

// このファイルはジム詳細（rental_gym#detail）と予約リスト（reservation_list）の
// 両方から読み込まれる。レビュー画面のようにスライダーを持たないページからも
// 同じ pack が読まれるため、要素の有無を必ず確認してから初期化する。
let swiperInstances = [];

function initSwipers() {
  // Turbolinks で戻ったときの二重初期化を防ぐため、先に破棄する
  destroySwipers();

  document.querySelectorAll(".swiper").forEach((element) => {
    const slideCount = element.querySelectorAll(".swiper-slide").length;

    // 矢印はスライダーごとに探す。
    // グローバルセレクタ（".sliders-arrow--right"）を Swiper に渡すと、
    // 同一画面に複数のスライダーが並んだときに衝突するため、
    // 祖先要素の中から引いた HTMLElement を直接渡す。
    const scope = element.closest(".gymdetail-img") || document;
    const nextEl = scope.querySelector(".sliders-arrow--right");
    const prevEl = scope.querySelector(".sliders-arrow--left");
    const slidersAction = scope.querySelector(".sliders-action");

    // Swiper 9 以降の loop は複製方式をやめたため、
    // 「スライド数が slidesPerView の 2 倍以上」であることが条件になった。
    // 追加画像（gym_option_images）を登録していないジムはメイン画像 1 枚だけなので、
    // その場合は loop を無効にする。
    const enableLoop = slideCount >= 2;

    // スライドが 1 枚のときは操作しても何も起きないため、矢印ごと隠す
    if (!enableLoop && slidersAction) {
      slidersAction.style.display = "none";
    }

    const swiper = new Swiper(element, {
      modules: [Navigation],
      slidesPerView: 1,
      spaceBetween: 2,
      loop: enableLoop,
      navigation: nextEl && prevEl ? { nextEl, prevEl } : false,
    });

    // 画像カウンター（「1 / 2」の左側）はジム詳細にのみ存在する。
    // DOM 上の位置を表す activeIndex ではなく、実スライドの位置である realIndex を使う。
    const currentLabel = scope.querySelector(".image-count .current");
    if (currentLabel) {
      swiper.on("slideChange", () => {
        currentLabel.textContent = swiper.realIndex + 1;
      });
    }

    swiperInstances.push(swiper);
  });
}

function destroySwipers() {
  swiperInstances.forEach((swiper) => {
    if (swiper && !swiper.destroyed) {
      // 第 2 引数を true にして、Swiper が付与したクラスと inline style も戻す。
      // これをしないと Turbolinks のキャッシュに変形後の DOM が残り、
      // 戻る操作のあとにスライドの順序や矢印の挙動が壊れる。
      swiper.destroy(true, true);
    }
  });
  swiperInstances = [];
}

// 画面 height が低い場合のカード高さ制御
function initCardScrollControl() {
  const elm = $(".gymdetail-box-2");
  if (elm.length === 0) return;

  const target = elm.find(".gym-box");
  const elmInitH = elm.innerHeight();
  const targetInitH = target.innerHeight();
  const headerH = $(".gym-kari-header").innerHeight();
  const adjustH = headerH + Math.floor(elmInitH - targetInitH); // 86px

  const apply = () => {
    if (targetInitH > $(window).innerHeight() - adjustH) {
      target
        .css({ height: `calc(100vh - ${adjustH}px)` })
        .find(".gym-box-inner")
        .addClass("is-scroll");
    } else {
      target.css({ height: "" }).find(".gym-box-inner").removeClass("is-scroll");
    }
  };

  // 名前空間付きイベントにして、再初期化のたびにハンドラが積み上がるのを防ぐ
  $(window).off("load.gymDetail resize.gymDetail").on("load.gymDetail resize.gymDetail", apply);
  apply();
}

function init() {
  initSwipers();
  initCardScrollControl();
}

$(function () {
  init();
});

// Turbolinks でのページ遷移後も初期化する
document.addEventListener("turbolinks:load", init);

// キャッシュに保存される前に Swiper を破棄して DOM を元に戻す
document.addEventListener("turbolinks:before-cache", destroySwipers);
